'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.nearbyPopularVenues = exports.venueSiblings = exports.reviewsForVenue = exports.similarVenues = exports.scheduleForVenue = exports.venueByIdV2 = exports.venueListV2 = exports.venueList = undefined;

var _sagaTools = require('@classpass/saga-tools');

var venueList = exports.venueList = (0, _sagaTools.makeEntityScaffold)('SAGA.API.VENUES', function (client, options, overrides) {
  return client.venues.getList(options, overrides).then(function (data) {
    return {
      venues: data.venues,
      meta: data.meta ? {
        numPages: data.meta.num_pages,
        currentPage: data.meta.current_page,
        totalCount: data.meta.total_count
      } : {}
    };
  });
});

var venueListV2 = exports.venueListV2 = (0, _sagaTools.makeEntityScaffold)('SAGA.API.VENUES_V2', function (client, options, overrides) {
  return client.venues.getListV2(options, overrides).then(function (data) {
    return {
      venues: data.venues,
      meta: data.meta ? {
        numPages: data.meta.num_pages,
        currentPage: data.meta.current_page,
        totalCount: data.meta.total_count
      } : {}
    };
  });
});

var venueByIdV2 = exports.venueByIdV2 = (0, _sagaTools.makeEntityScaffold)('SAGA.API.VENUE_BY_ID_V2', function (client, venueId, options) {
  return client.venues.getVenueByIdV2(venueId, options);
}, { defaultKey: 1 });

var scheduleForVenue = exports.scheduleForVenue = (0, _sagaTools.makeEntityScaffold)('SAGA.API.SCHEDULE_FOR_VENUE', function (client, venueId, options) {
  var getFullObject = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  return client.venues.getSchedulesPerVenue(venueId, options).then(function (data) {
    return getFullObject ? data : data.schedules;
  });
}, { defaultKey: 1 });

var similarVenues = exports.similarVenues = (0, _sagaTools.makeEntityScaffold)('SAGA.API.SIMILAR_VENUES', function (client, venueId, options) {
  return client.venues.getVenueSimilarities(venueId, options).then(function (data) {
    return data.venues;
  });
}, { defaultKey: 1 });

var reviewsForVenue = exports.reviewsForVenue = (0, _sagaTools.makeEntityScaffold)('SAGA.API.REVIEWS_FOR_VENUE', function (client, venueId) {
  var page = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  var perPage = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 25;
  return client.venues.getVenueReviews(venueId, {
    page_size: perPage,
    page: parseInt(page, 10),
    meta: true
  });
}, { defaultKey: [1, 2] });

var venueSiblings = exports.venueSiblings = (0, _sagaTools.makeEntityScaffold)('SAGA.API.VENUE_SIBLINGS', function (client, venueId, options) {
  return client.venues.getVenueSiblings(venueId, options);
}, { defaultKey: 1 });

var nearbyPopularVenues = exports.nearbyPopularVenues = (0, _sagaTools.makeEntityScaffold)('SAGA.API.NEARBY_POPULAR_VENUES', function (client, msaId, overrides) {
  return client.venues.getNearbyPopularVenue(msaId, overrides).then(function (data) {
    return {
      venues: data.venues,
      meta: data.meta ? {
        numPages: data.meta.num_pages,
        currentPage: data.meta.current_page,
        totalCount: data.meta.total_count
      } : {}
    };
  });
}, { defaultKey: 1 });